export const shouldFetchShades = ({
  productCode,
  products
}) => Boolean(productCode) && (products?.length ?? 0) === 0;
//# sourceMappingURL=shouldFetchShades.js.map